export const TableHeaders = [
  { column: 'assessmentType', label: 'Assessment type', width: '15%', sortBy: 'text' },
  { column: 'tier', label: 'Tier', width: '15%', sortBy: 'text' },
  { column: 'ptReferralSource', label: 'Referral source', width: '20%', sortBy: 'text' },
  { column: 'initialPatient', label: 'Existing patient', width: '10%', sortBy: 'text' },
  { column: 'npi', label: 'NPI', width: '15%', sortBy: 'text' },
  { column: 'assessmentDate', label: 'Assessment date', width: '15%', sortBy: 'value' },
  { column: 'actions', label: 'Actions', width: '10%' },
];
